import script from "./MChipsInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./MChipsInput.vue?vue&type=script&lang=ts&setup=true"

import "./MChipsInput.vue?vue&type=style&index=0&id=3bead33c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bead33c"]])

export default __exports__